const sliderPollState = {
  title: 'Slider poll title',
  description: 'Choose the best option',
  engagementData: {
    engagementType: 'sliderPoll',
    engagementTemplate: 'sliderPollOne',
    options: [
      {
        title: '',
        mark: true,
      },
      {
        title: '',
        mark: false,
      },
      {
        title: '',
        mark: false,
      },
      {
        title: '',
        mark: false,
      },
      {
        title: '',
        mark: false,
      },
      {
        title: '',
        mark: false,
      },
      {
        title: '',
        mark: false,
      },
      {
        title: '',
        mark: false,
      },
      {
        title: '',
        mark: true,
      },
    ],
  },
};

export default sliderPollState;
